<template>
  <v-card>
    <v-toolbar dense flat dark :color="toolbarColor">
      <v-toolbar-title>
        <span class="font-weight-light body-1">Kiosk Type</span>
      </v-toolbar-title>

      <v-spacer />

      <v-toolbar-items>
        <v-btn @click="close()" fab small class="elevation-0 mr-n2" :color="toolbarColorDark">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>

    <v-list-item-group>

      <v-list-item @click="close(kioskTypeId_Abby, 22)" class="py-2">
        <v-list-item-title>
          <v-img :src="imageUri_Abby" width="90" contain />
        </v-list-item-title>
        <v-list-item-action>
          <span class="subtitle font-weight-black">v22</span>
        </v-list-item-action>
      </v-list-item>

      <v-divider />

      <v-list-item @click="close(kioskTypeId_Abby, 21)" class="py-2">
        <v-list-item-title>
          <v-img :src="imageUri_Abby" width="90" contain />
        </v-list-item-title>
        <v-list-item-action>
          <span class="subtitle font-weight-black">v21</span>
        </v-list-item-action>
      </v-list-item>

      <v-divider />
      
      <v-list-item @click="close(kioskTypeId_Abby, null)" class="py-2">
        <v-list-item-title>
          <v-img :src="imageUri_Abby" width="90" contain />
        </v-list-item-title>
        <v-list-item-action>
          <span class="subtitle font-weight-black">v3</span>
        </v-list-item-action>
      </v-list-item>

      <v-divider />

      <v-list-item @click="close(kioskTypeId_Genie, null)" class="py-2">
        <v-list-item-title>
          <v-img :src="imageUri_Genie" width="100" contain />
        </v-list-item-title>
      </v-list-item>

    </v-list-item-group>
  </v-card>
</template>

<script>
import { AppColor, KioskTypeId, ImageUri } from '@/config.js'

export default {
  name: 'KioskTypeSelector',
  props: {
    label: {
      type: String,
      default: 'content'
    },
    toolbarColor: {
      type: String,
      default: AppColor.Medium
    },
    toolbarColorDark: {
      type: String,
      default: AppColor.Dark
    }
  },
  data() {
    return {
      // colors
      appColor_Medium: AppColor.Medium,

      // kiosk types
      kioskTypeId_Abby: KioskTypeId.Abby,
      kioskTypeId_Genie: KioskTypeId.Genie,

      // uri
      imageUri_Abby: ImageUri.AbbyKiosk,
      imageUri_Genie: ImageUri.GenieKiosk
    }
  },
  methods: {
    close (kioskType, phidgetVersion) {
      this.$emit('close', kioskType, phidgetVersion)
    }
  }
}
</script>